module.exports = __webpack_public_path__ + "img/web5.17984944.png";